<template>
	<div class="cart-item-row">
		<div v-if="product.saleMessage">
			<center class="top0" style="color:red;padding-bottom:0px;">{{ product.saleMessage }} <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ product.salePrice }}</span></center>
		</div>
		<div v-if="product.sale">
			<center class="top0" style="color:red;padding-bottom:0px;">Save <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ product.sale }}</span> Each!</center>
		</div>
				<div class="cart-item-img-cell">
					<div class="cart-item-img"><img :src="product.image"></div>
				</div>
				<div class="cart-item-desc">
					<var>{{ product.name }} </var>
					<h4 v-if="product.flavor">Flavor: <var>{{ product.flavor }}</var></h4>
					<h4 v-if="product.size">Concentration: <var>{{ product.size }}</var></h4>
					<div notranslate v-if="product.specialPackSubProducts">
						<p v-for="subProduct in product.specialPackSubProducts"  :key="subProduct.id" class="no-margin-bottom unset-font">
							{{ subProduct.quantity }}
							{{ subProduct.name }}
							<span class="pos-static unset-font" v-if="subProduct.flavor">
								- {{ subProduct.flavor }}
							</span>
							<span class="pos-static unset-font" v-if="subProduct.size">
								({{ subProduct.size }})
							</span>
						</p>
					</div>
                                        <div v-if="product.autoPrice>.1 && product.autoPrice!=product.price && product.autoship && membership >=1">
                                           <span class="itembar-subcribed">
                                              <i class="fa-solid fa-check"></i> Subscribe & Save <div style="display:none">{{ subscribeOff }}%</div>
                                            </span>
                                        </div>
				</div>
				<div v-if="max > 1 && !product.free" class="cart-item-qty-cell">
			        <div class="cart-item-qty-options">
					    <input type="button" value="-" @click="decreaseItem"><var>{{ quantity }}</var><input type="button" value="+" @click="increaseItem"> 
					</div>
				</div>
				<div v-else-if="product.free" class="cart-item-qty-cell">
					<var>{{ quantity }}</var>
				</div>
				<div v-else-if="product.isSpecialPackMainProduct" class="cart-item-qty-cell">
					<var>{{ quantity }}</var>
				</div>
				<div v-else class="cart-item-qty-cell">
					<p class="no-margin-bottom">1</p>
				</div>
				<div v-if="!product.free && !product.sale && !(product.autoPrice>.1 && product.autoPrice!=product.price && product.autoship && membership >=1)" :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft" class="cart-item-price" :style="{'margin-top': 0}"><var>{{ formatPrice }}</var>
				</div>
                                <div v-if="product.autoPrice>.1 && product.autoPrice!=product.price && product.autoship && membership>=1">
                                   <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft" style="text-decoration:line-through">{{ product.retailPrice }}</span></s><br>
                                   <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ formatPrice }}</span>
                                </div>
                                <div v-if="product.free && product.condition_message">
                                 <var>FREE*<br>*{{ product.condition_message }}</var>
                                </div>
				<div v-if="product.sale" class="cart-item-price">
						<s><span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft" style="text-decoration:line-through">{{ formatPrice }}</span></s><br>
						<span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ salePrice }}</span>
				</div>	
				<div v-if="product.allowAutoship" class="slider-parent">
					<div class="slight-margin-right">Autoship</div>
					<checkbox-slider v-model="autoship"></checkbox-slider>
				</div>
				<div v-if="!product.free" class="cart-item-delete">
					<i class="fa-regular fa-trash-can cursor-pointer" @click="deleteItem"></i>
				</div>				
	</div>
</template>

<style scoped>
	.slider-parent {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}
	.slight-margin-right {
		margin-right: 5px;
	}
	.pos-static {
		position:static !important;
	}
	.unset-font {
		font-size: unset !important;
	}
	.cursor-pointer {
		cursor: pointer;
	}
	.no-margin-bottom {
		margin-bottom: 0;
	}
	.flex-row {
		display: flex;
		flex-direction: row;
	}
	.flex-column {
		display: flex;
		flex-direction: column;
	}

	.indented {
		width: 90%;
		align-self: flex-end;
	}

	.tiny-padding {
		padding: 5px;
	}

	.space-between {
		justify-content: space-between;
	}

	.align-items-center {
		align-items: center;
	}
</style>

<script>
	import CheckboxSlider from './CheckboxSlider.vue'
    export default {
		components: {
			CheckboxSlider
		},
        props: {
            product: Object,
            currencySymbolRight: String,
            currencySymbolLeft: String,
            membership: Number
		},
		data: function () {
			return {
				quantity: this.product.quantity,
				max: this.product.max,
				autoship: this.product.allowAutoship && this.product.autoship,
                salePrice: (this.product.price - this.product.sale).toFixed(2)          
			}
		},
		watch: {
			autoship(n) {
				this.autoshipChanged(n)
			},
			quantity(n) {
				this.quantityChanged(n)
			}
		},
		methods: {
			// increaseQuantity: function () {
			// 	this.product.quantity += 1;
			// 	this.$emit('increaseQuantity', this.product);
			// },
			// decreaseQuantity: function () {
			// 	this.product.quantity -= 1;
			// 	this.$emit('decreaseQuantity', this.product);
			// },
			autoshipChanged(autoship) {
				this.product.autoship = autoship
				this.$emit('changeProduct', this.product)
			},
			quantityChanged: function (quantity) {
				this.product.quantity = quantity;
				this.$emit('changeProduct', this.product);
			},
			deleteItem: function () {
				this.product.quantity = 0;
				this.$emit('changeProduct', this.product);
			},
			increaseItem: function () {
				this.product.quantity = this.product.quantity + 1;
				this.$emit('changeProduct', this.product);				
			},				
			decreaseItem: function () {
				this.product.quantity = this.product.quantity - 1;
				this.$emit('changeProduct', this.product);				
			}
		},
		computed: {
			calculatedBV: function () {
				if (this.product.product_months > 1) {
					return this.product.bv + this.product.monthly_bv * (this.product.product_months - 1)
				} else {
					return this.product.bv
				}
			},
			formatPrice: function () {
                           let productPrice = this.product.retailPrice
                              if (this.membership >= 1) {
                                 productPrice = this.product.price
                              }
                              if (this.product.autoship && this.product.autoPrice && this.membership >= 1) {
                                 productPrice = this.product.autoPrice
                              }

//		               let subTotalDecimal = productPrice - Math.floor(productPrice);
                              let subTotalDecimal = productPrice

				if (subTotalDecimal > 0) {
					return productPrice;
				} else {
					return parseInt(productPrice);
				}
			},
                        subscribeOff: function () {
                                let subscribeOff = ((this.product.price - this.product.autoPrice) / this.product.price) * 100
                                subscribeOff = Math.floor(subscribeOff)
                                return subscribeOff
                        }
		}
    }

</script>

<style>
</style>
